// --------------------------------------------------------------------------
// underlineSplit.js
// --------------------------------------------------------------------------
// Splits headings into spans for underline decoration
// --------------------------------------------------------------------------

EC.underlineSplit = function () {

    'use strict';

    function init () {
        $('.js-underline-split').each(splitToSpans);
    }

    function splitToSpans () {
        const words = this.textContent.split(' ');
        const wrappedWords = words.map(spanWrap);
        if(this.dataset.break == 'break'){
            this.innerHTML = wrappedWords.join('<br>');
        }
        else if(this.dataset.break == 'space'){
            this.innerHTML = wrappedWords.join(' ');
        } else{
           this.innerHTML = wrappedWords.join(''); 
        }
        
    }

    function spanWrap(word){
        return `<span class="e-underline-heading__break"><span class="e-underline-heading__copy">${word}</span></span>`;
    }

    return {
        init: init
    };

}();